module.exports = __webpack_public_path__ + "img/wfg.c08b7d7e.jpg";